import React, {useState} from 'react';
import {GuardedRoute} from 'react-router-guards';
import Section from '../../../../components/Section/Section';

const ZooData = ({match}) => {
  const [templateData] = useState([
    {
      category: 'Dados Zootécnicos',
      options: [
        {
          group: ' ',
          options: [
            {
              title: 'Informações técnicas',
              //   url: `${match.url}/tipo/receitas`,
            },
            {
              title: 'Qualidade do leite',
              //   url: `${match.url}/tipo/despesas`,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <div className="zoodata">
      <GuardedRoute exact path={match.url} meta={{moduleName: 'Dados Zootécnicos'}} render={() => <Section templateData={templateData} />} />
    </div>
  );
};
export default ZooData;
